import React, { PropsWithChildren } from "react";
import { classes } from "lib/actions/util";
import Card from "components/elements/Card/Card";
import ButtonCard from "../Card/ButtonCard";
import { ButtonProps } from "react-html-props";

export interface SecondaryButtonProps {
  className?: string;
  colourSchemeVariant?: "neutral" | "red" | "custom";
  buttonProps?: ButtonProps;
}

function CardSecondaryButton({
  children,
  className,
  colourSchemeVariant = "neutral",
  buttonProps,
}: PropsWithChildren<SecondaryButtonProps>) {
  return (
    <div className="absolute right-0 -ml-1 h-full w-8 shrink-0">
      <button
        type="button"
        {...buttonProps}
        className={classes(
          "group/context flex h-full w-full flex-1 items-center justify-center rounded-r-md border border-neutral-200 transition-colors duration-200",
          colourSchemeVariant === "neutral" &&
            "bg-neutral-50 text-icon-normal hover:text-icon-hover",
          colourSchemeVariant === "red" &&
            "bg-red-50 text-red-400 transition-colors hover:bg-red-100 hover:text-red-600",
          className,
        )}
      >
        {children}
      </button>
    </div>
  );
}

export default function ListItemWithSecondaryButton(
  p: {
    children: React.ReactNode;
    primaryButtonProps?: ButtonProps;
    secondaryButtonProps?: SecondaryButtonProps;
    secondaryButtonContent?: React.ReactNode;
    inlineRightContent?: React.ReactNode;
  } & {
    ref?: React.RefObject<HTMLDivElement>;
  },
) {
  return (
    <div ref={p.ref} className="relative flex min-h-12">
      {p.primaryButtonProps?.onClick ? (
        <ButtonCard
          {...p.primaryButtonProps}
          className={classes(
            "flex w-full min-w-0 items-center px-2",
            p.inlineRightContent ? "pr-[4.5rem]" : "pr-8",
          )}
        >
          {p.children}
        </ButtonCard>
      ) : (
        <Card
          hasShadow={false}
          className={classes(
            "flex w-full min-w-0 cursor-default items-center px-2",
            p.inlineRightContent ? "pr-[4.5rem]" : "pr-8",
          )}
        >
          {p.children}
        </Card>
      )}
      {p.inlineRightContent && (
        <div className="absolute right-8 top-0 flex h-full items-center">
          {p.inlineRightContent}
        </div>
      )}
      <CardSecondaryButton {...p.secondaryButtonProps}>
        {p.secondaryButtonContent}
      </CardSecondaryButton>
    </div>
  );
}
